import {MaterialType} from '@domain/material-storage'
import {ContentMode} from '@hconnect/common/components/ContentBox'
import {TimeRange} from '@hconnect/common/types'
import {formatDateTime} from '@hconnect/common/utils/datetime.utils'
import {dataTestId} from '@hconnect/uikit'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {Stack, Tooltip, Typography} from '@mui/material'
import {MaterialStorageContainer} from '@widgets/silo-fill-levels'
import moment from 'moment-timezone'
import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {useMaterialStorageWithFallback} from '../hooks'
import {selectLatestSortedMaterialStorages} from '../utils'

type Props = {
  plantId: string
  contentMode: ContentMode
  timeRange: TimeRange
  isSingleShift?: boolean
}

export const SiloFillsContainer: React.FC<Props> = ({
  plantId,
  contentMode,
  timeRange,
  isSingleShift
}) => {
  const {endDate: snapshotDateTime} = timeRange
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const timezone = useUpmPlantTimezone(plantId)

  const [selectedMaterialType, setSelectedMaterialType] = useState<MaterialType>(
    MaterialType.Cement
  )

  const {
    data: materialStorageData,
    isLoading: isMaterialStorageDataLoading,
    error: materialStorageDataError
  } = useMaterialStorageWithFallback({
    plantId,
    snapshotDateTime,
    options: {
      select: selectLatestSortedMaterialStorages(selectedMaterialType)
    }
  })

  return (
    <Tooltip
      placement="top"
      title={
        !isSingleShift ? (
          <Stack>
            <Typography {...dataTestId('silo_fill_level_information_tooltip')}>
              {t('productionVolume.label.siloFillLevelForTheLatestShift')}
            </Typography>
            {formatDateTime(moment.utc(snapshotDateTime).tz(timezone))}
          </Stack>
        ) : (
          ''
        )
      }
    >
      <span>
        <MaterialStorageContainer
          contentMode={contentMode}
          materialStorageData={materialStorageData}
          plantCode={plantId}
          isLoading={isMaterialStorageDataLoading}
          error={materialStorageDataError}
          setSelectedMaterialType={setSelectedMaterialType}
          snapshotDateTime={formatDateTime(moment.utc(snapshotDateTime).tz(timezone))}
        />
      </span>
    </Tooltip>
  )
}
